import { css } from 'emotion'

export const LabelsMainStyles = css``
